<template>
  <div class="login-view">
    <div class="login-view-body">
      <div class="login-view-bg">
        <img src="@/assets/login_bg.png" style="width: 765px; height: 648px;"/>
      </div>
      <div class="login-view-container">
        <el-col :span="12">
          <el-form :rules="rules" ref="loginForm" :model="loginForm" class="login-container">
            <img class="login-logo" style="width: 381px; height: 56px;" src="@/assets/login_logo.png"/>
            <el-form-item prop="username">
              <el-input class="login-username" type="text" v-model="loginForm.username" placeholder="请输入管理员用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input class="login-password" type="password" v-model="loginForm.password" placeholder="请输入管理员密码" show-password></el-input>
            </el-form-item>
            <el-button class="login-button" type="primary" @click="submitLogin" :loading="isLoading">{{ loginButtonText }}</el-button>
          </el-form>
        </el-col>
      </div>
    </div>
    <div class="login-view-footer">
      Copyright @ 2024 COOKOO Technology Co., LTD. All Rights Reserved.
    </div>
  </div>
</template>

<script>
import eventBus from '../event-bus.js'
import { ElMessage } from 'element-plus'
import RttysAuth from '../js/rttysAuth.js'
import md5 from 'js-md5'

export default {
  name: 'LoginView',
  data () {
    return {
      isLogin: false,
      loginForm: {
        username: '',
        password: '',
        code: '',
        logoUrl: require('@/assets/login_logo.png')
      },
      isLoading: false,
      loginButtonText: '登录'
    }
  },
  mounted () {
    eventBus.emit('login_success', false)
  },
  methods: {
    submitLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (this.loginForm.username === null || this.loginForm.username === undefined || this.loginForm.username.trim() === '') {
          ElMessage.info('请输入账号!')
          return
        }

        if (this.loginForm.password === null || this.loginForm.password === undefined || this.loginForm.password.trim() === '') {
          ElMessage.info('请输入密码!')
          return
        }

        this.isLoading = true
        this.loginButtonText = ' '
        const username = this.loginForm.username
        const password = md5(this.loginForm.password)
        this.isLogin = false

        this.$axios({
          method: 'post',
          url: '/account/sysLogin',
          timeout: 10000,
          data: { username: username, password: password, loginTerminal: 1 }
        })
          .then(response => {
            // const toUrl1 = this.redirect || '/main'
            // this.$router.push(toUrl1)
            // console.log(this.redirect, ' | ', toUrl1)
            console.log(JSON.stringify(response))
            const httpStatus = response.status
            if (httpStatus !== 200) {
              ElMessage.error('登录失败, 错误描述：' + response.statusText)
              return
            }
            const root = response.data
            const serverStatus = root.code
            if (serverStatus !== 200) {
              ElMessage.error('登录失败, 错误描述：' + root.msg)
              return
            }
            const data = root.data
            ElMessage({ message: '登录成功!', type: 'success' })
            this.isLogin = true

            const auth = new RttysAuth('', 'sid')

            // 登录
            auth.login('cookoo.com')

            // this.loginSuccess()
            localStorage.clear()
            const userInfo = {
              isLogin: true,
              userName: data.uname,
              userId: data.uid,
              created: data.created,
              createdTime: data.createdTime,
              roleId: data.roleid,
              roleName: data.roleName,
              sessionId: data.sessionId,
              password: data.upwd
            }
            // console.log("userId=" + data.userId + ", sessionId=" + data.sessionId + ", roleId=" + data.roleId)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.$store.state.userInfo = userInfo
            // console.log('login-redirect: ', this.redirect)
            const toUrl = this.redirect || '/main'
            this.$router.push(toUrl)
          })
          .catch(error => {
            console.log(error)
            this.error = error
            this.isLogin = false
            ElMessage.error('登录失败, ' + error)
          })
          .finally(() => {
            this.isEnd = true
            this.isLoading = false
            this.loginButtonText = '登录'
            eventBus.emit('login_success', this.isLogin)
          })
      })
    }
  }
}
</script>

<style scoped>
.login-view {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  min-width: 1500px;
}

.login-view-body {
  width: 100%;
  height: calc(100% - 48px);
  /* background-color: rgb(183, 207, 142); */
  display: flex;
  flex-direction: row;
}

.login-view-bg {
  width: 50%;
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-view-container {
  width: 50%;
  height: 100%;
  /* background-color: rgb(149, 221, 181); */
  /* width: 100vw;
  height: 100vh;
  background-color: #E1E9E8;
  background-size:100%; */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-view-footer {
  width: 100%;
  height: 48px;
  background-color: #F6F6F6;
  font-family: 'Microsoft YaHei, Microsoft YaHei';
  font-weight: 400;
  font-size: 12px;
  color: rgba(0,0,0,0.4);
  line-height: 48px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  align-items: center;
}

.login-container {
  float: right;
  border-radius: 4px;
  /* background-clip: padding-box; */
  /* text-align: left; */
  /* margin: auto auto auto auto; */
  /* margin-right: 20%; */
  width: 616px;
  height: 526px;
  /* padding: 15px 40px 30px 40px; */
  background: #ffffff;
  /* border:1px solid #f0f9eb; */
  /* box-shadow: 0 0 10px #b1b3b8; */
}

.login-logo {
  /* background-image: url('@/assets/login_logo.png'); */
  object-fit: contain;
  margin: 72px auto 0px auto;
  display: block;
}

.login-username {
  margin: 76px auto 0px auto;
  width: 400px;
  height: 48px;
}

.login-password {
  margin: 8px auto 6px auto;
  width: 400px;
  height: 48px;
}

.login-button {
  margin: 40px auto 16px auto;
  background-color: #14A97C;
  display: block;
  width: 400px;
  height: 48px;
}

.login-button:hover {
  background-color: #1cc995; /* 设置 hover 时的背景色 */
  border-color: #14A97C; /* 设置 hover 时的边框颜色 */
  color: #ffffff; /* 设置 hover 时的文字颜色 */
}

</style>
